import * as types from '../mutation-types'
import { API } from '../../api'

export default {
    namespaced: true,
    state: {
        fromEmbedded: false,
        hideTitle: false,
        userUid: '',
        userVip: undefined,
        nickName: '',
        detailInfo: {},
        queryData: {}
    },
    getters: {},
    mutations: {},
    actions: {
        initEmbeddedDetailInfo({state}, params) {
            state.fromEmbedded = true;
            state.userUid = parseInt(params.queryData.uid, 10);
            state.userVip = params.queryData.vip ? parseInt(params.queryData.vip) : state.userVip;
            state.nickName = params.queryData.nickname;
            state.hideTitle = params.queryData.hideTitle;
            state.queryData = _.omit(params.queryData, ['uid', 'id', 'vip', 'nickname', 'from']);
            console.log('initEmbeddedDetailInfo------', state.queryData, params.queryData);
            
            API.getDetailInfo({
                id: params.queryData.id
            }, function(data){
                console.log('获取八字信息成功::::::', data);
                state.detailInfo = data;
                if(params.cb && typeof(params.cb) == 'function') {
                    params.cb(data);
                }
            });
        },
        resetData({state}) {
            state.fromEmbedded = false;
            state.nickName = '';
            state.detailInfo = {};
            state.queryData = {};
        }
    }
}